import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { formatearRut } from '../../utils/validaciones';
import './LoginEspacios.css';

const LoginEspacios = () => {
  const [rut, setRut] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  const isLocal = window.location.hostname === 'localhost' || window.location.hostname === '127.0.0.1';
  const apiBase = isLocal
    ? `http://${window.location.hostname}:3010`
    : `${window.location.protocol}//${window.location.hostname}`;

  const cleanRut = (value) => value.replace(/[^0-9kK]/g, '');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    const formattedRut = rut.toLowerCase() === 'admin' ? rut : cleanRut(rut);

    try {
      const resp = await fetch(`${apiBase}/api/espacios/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ rut: formattedRut, password })
      });

      if (resp.ok) {
        const data = await resp.json();
        localStorage.setItem('user_espacios', JSON.stringify(data.user));
        navigate('/espacios/home');
      } else {
        const errData = await resp.json();
        setError(errData.error || 'Credenciales no autorizadas.');
      }
    } catch (err) {
      setError('Error de conexión con el servidor municipal.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-esp-container">
      {/* Decorative Background Elements */}
      <div className="bg-blob blob-1"></div>
      <div className="bg-blob blob-2"></div>

      <div className="login-esp-card">
        <div className="login-esp-header">
          <div className="login-esp-logo-icon">
            <i className="fa-solid fa-map-location-dot" style={{ fontSize: '32px', color: '#10b981' }}></i>
          </div>
          <h2>Gestor de Espacios</h2>
          <p>Control y Reservas de Recintos Municipales</p>
        </div>

        {error && (
          <div className="animate-fade-in" style={{
            color: 'var(--p-rose)',
            backgroundColor: 'rgba(244, 63, 94, 0.1)',
            border: '1px solid rgba(244, 63, 94, 0.2)',
            padding: '12px',
            borderRadius: '12px',
            marginBottom: '20px',
            fontSize: '13px',
            textAlign: 'center',
            fontWeight: '600'
          }}>
            <i className="fa-solid fa-circle-exclamation" style={{ marginRight: '8px' }}></i>
            {error}
          </div>
        )}

        <form onSubmit={handleSubmit} className="login-esp-form">
          <div className="input-group">
            <label>RUT Autorizado</label>
            <div style={{ position: 'relative' }}>
              <i className="fa-solid fa-id-card" style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: 'var(--p-slate)' }}></i>
              <input
                type="text"
                value={rut}
                onChange={(e) => setRut(e.target.value)}
                onBlur={(e) => setRut(formatearRut(e.target.value))}
                placeholder="12.345.678-9"
                style={{ paddingLeft: '45px' }}
                required
              />
            </div>
          </div>

          <div className="input-group">
            <label>Contraseña</label>
            <div style={{ position: 'relative' }}>
              <i className="fa-solid fa-lock" style={{ position: 'absolute', left: '16px', top: '50%', transform: 'translateY(-50%)', color: 'var(--p-slate)' }}></i>
              <input
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="••••••••"
                style={{ paddingLeft: '45px' }}
                required
              />
            </div>
          </div>

          <button type="submit" className="login-button" disabled={loading}>
            {loading ? <span className="spinner"></span> : 'Ingresar al Sistema'}
          </button>
        </form>

        <div className="back-to-activos">
          <button 
            type="button"
            className="btn-secondary-outline"
            onClick={() => navigate('/')}
          >
            <i className="fa-solid fa-arrow-left"></i>
            <span>Volver al Gestor de Activos</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default LoginEspacios;
